import React from 'react';
import {Spin} from "antd";
import styled from "styled-components";

const SpinDiv = styled.div`
    text-align: center;
    display: none;
`;
const Spinner = () =>
    <SpinDiv id="spinner" >
        <Spin tip="Loading..." size="large"/>
    </SpinDiv>;
export default Spinner;

export function spinnerOff () {
    if(document.getElementById('spinner')){
        document.getElementById('spinner').style.display='none';
    }
}
export function spinnerOn () {
    if(document.getElementById('spinner')) {
        document.getElementById('spinner').style.display = 'block';
    }
}
export function isSpinnerShowing() {
    let retVal = false;
    if(document.getElementById('spinner')) {
        retVal = document.getElementById('spinner').style.display === 'block';
    }
    return retVal;
}
